const calculateAveragePoints = (response) => {
  return response.averageScore * response.count;
};
export const renderSuccess = (formElement, response) => {
  const resultWrapper = formElement.parentElement.querySelector(".quiz__result-wrapper");
  resultWrapper.querySelector(".quiz__result-own-performance").textContent = `Du hast ${response.countCorrect} von ${response.count} Fragen richtig beantwortet!`;
  resultWrapper.querySelector(".quiz__result-rating").innerHTML = response.quizResponseText;
  resultWrapper.querySelector(".quiz__result-average").textContent = calculateAveragePoints(response).toFixed(2);
  formElement.classList.add("hidden");
  resultWrapper.classList.remove("hidden");
  resultWrapper.querySelector(".button--page-reload").addEventListener("click", function() {
    window.location.reload();
  });
};
